// src/pages/NotFoundPage.js - 404 page component
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';

const NotFoundContainer = styled.div`
  text-align: center;
  margin: var(--spacing-xxl) auto;
  max-width: 600px;
`;

const NotFoundTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: var(--spacing-md);
`;

const NotFoundText = styled.p`
  font-size: 1.25rem;
  margin-bottom: var(--spacing-xl);
  color: var(--text-light);
`;

const NotFoundEmoji = styled.div`
  font-size: 4rem;
  margin-bottom: var(--spacing-lg);
`;

const NotFoundPage = () => {
  return (
    <NotFoundContainer>
      <NotFoundEmoji role="img" aria-label="page not found">
        🔍
      </NotFoundEmoji>
      <NotFoundTitle>Page Not Found</NotFoundTitle>
      <NotFoundText>
        The page you're looking for doesn't exist or has been moved.
      </NotFoundText>
      <Button as={Link} to="/" size="large">
        Return to Home
      </Button>
    </NotFoundContainer>
  );
};

export default NotFoundPage; 